import React, { useRef } from 'react';
import ReactDatePicker from 'react-datepicker';
import { Controller } from 'react-hook-form';
import { DateTypePicker } from '../../../../../../DatePicker';
import { IFieldFieldsFragment } from '../../../../../../../utils/apollo/graphqlSchema';
import useFilterWidgetFormContext from '../../../../../utils/useFilterWidgetFormContext';
import BetweenFields from '../../../../../../Form/BetweenFields';
import { IPredicateFormFieldPath } from '../../../../../types';
import { getPredicateFormFieldPath } from '../../../../../utils/formPath';
import { getFieldValueKey } from '../../../../../../../utils/analytics/events/filter/utils';
import { createBasicFieldValue } from '../../../../../utils/createBasicFieldValue';

interface IProps {
  formPath: IPredicateFormFieldPath;
  selectedField: IFieldFieldsFragment;
  placeholder: string;
  isBetween: boolean;
}

const DateTypeOperands = ({
  formPath,
  selectedField,
  placeholder,
  isBetween,
}: IProps) => {
  const endDatePickerRef = useRef<ReactDatePicker>(null);
  const startDatePickerRef = useRef<ReactDatePicker>(null);

  const { control } = useFilterWidgetFormContext();

  const fieldPath = getPredicateFormFieldPath(formPath);

  if (isBetween) {
    return (
      <BetweenFields>
        <Controller
          name={`${fieldPath}.operand.fromOperand`}
          control={control}
          render={({ field: { onChange, value }, fieldState }) => (
            <DateTypePicker
              ref={startDatePickerRef}
              fieldType={selectedField.type}
              placeholderText={placeholder}
              value={
                value?.__typename === 'BasicFieldValue'
                  ? getFieldValueKey(value)
                  : ''
              }
              onChange={(stringDate) => {
                onChange(createBasicFieldValue(stringDate));
                if (endDatePickerRef?.current) {
                  startDatePickerRef?.current?.setOpen(false);
                  endDatePickerRef.current.setOpen(true);
                }
              }}
              autoFocus={!value}
              isBetween={true}
              hasError={Boolean(fieldState.error)}
            />
          )}
        />
        <Controller
          name={`${fieldPath}.operand.toOperand`}
          control={control}
          render={({ field: { onChange, value }, fieldState }) => (
            <DateTypePicker
              ref={endDatePickerRef}
              fieldType={selectedField.type}
              placeholderText={placeholder}
              value={
                value?.__typename === 'BasicFieldValue'
                  ? getFieldValueKey(value)
                  : ''
              }
              onChange={(stringDate) => {
                onChange(createBasicFieldValue(stringDate));
              }}
              isBetween={true}
              hasError={Boolean(fieldState.error)}
            />
          )}
        />
      </BetweenFields>
    );
  }

  return (
    <Controller
      name={`${fieldPath}.operand.operands`}
      control={control}
      render={({ field: { onChange, value }, fieldState }) => (
        <DateTypePicker
          ref={startDatePickerRef}
          fieldType={selectedField.type}
          placeholderText={placeholder}
          value={
            value &&
            value.length > 0 &&
            value[0]?.__typename === 'BasicFieldValue'
              ? getFieldValueKey(value[0])
              : ''
          }
          onChange={(stringDate) => {
            onChange([createBasicFieldValue(stringDate)]);
            if (endDatePickerRef?.current) {
              startDatePickerRef?.current?.setOpen(false);
              endDatePickerRef.current.setOpen(true);
            }
          }}
          autoFocus={!value?.length}
          isBetween={false}
          hasError={Boolean(fieldState.error)}
        />
      )}
    />
  );
};

export default DateTypeOperands;
